export const env = {
  apiBaseUrl:  import.meta.env.VITE_API_BASE_URL  || 'http://localhost:8083',
  useAuth:     import.meta.env.VITE_API_USE_AUTH  == 'true',
  appName:     import.meta.env.VITE_APP_NAME      || 'Audit Tools Platform',
  appVersion:  import.meta.env.VITE_APP_VERSION   || '1.0.0',
  isDev:       import.meta.env.DEV,
  isProd:      import.meta.env.PROD,
}
